










import { Component, Mixins, Prop } from "vue-property-decorator"

import { EventMixin, TextMixin, WidgetMixin } from "./mixins"

const TYPES = ["button", "reset", "submit"];

@Component
export default class WButton extends Mixins(
  WidgetMixin,
  EventMixin,
  TextMixin
) {

  @Prop({ type: String, default: "primary" })
  variant!: string;

  @Prop({ type: Boolean, default: false })
  block!: boolean

  @Prop({
    type: String,
    default: "button",
    validator: (type) => TYPES.includes(type),
  })
  type!: string;
}
